import React from 'react';

const LegacyHeartIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="20" viewBox="0 0 22 20" fill="none">
      <path
        d="M17.6 12C19.09 10.54 20.6 8.79 20.6 6.5C20.6 5.04131 20.0205 3.64236 18.9891 2.61091C17.9576 1.57946 16.5587 1 15.1 1C13.34 1 12.1 1.5 10.6 3C9.09998 1.5 7.85998 1 6.09998 1C4.64128 1 3.24234 1.57946 2.21089 2.61091C1.17944 3.64236 0.599976 5.04131 0.599976 6.5C0.599976 8.8 2.09998 10.55 3.59998 12L10.6 19L17.6 12Z"
        stroke="#A2A2A2"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </svg>
  );
};

export default LegacyHeartIcon;
